import { CookieStorage } from 'cookie-storage'

export const cookieStorage = new CookieStorage({
  path: '/',
  domain: window.hsp.OIDC_COOKIE_DOMAIN
})
